export default "__VITE_ASSET__YOb3rZD7__"